// Shared Community Pulse helpers — one place for colours, words and the movement line.
export const BAND = {
  red: { word: "Red", dot: "#D32F2F", text: "text-[#B91C1C]", soft: "bg-[#FDF2F2]", ping: "0.9s" },
  yellow: { word: "Yellow", dot: "#D97706", text: "text-[#B45309]", soft: "bg-[#FFFBEB]", ping: "1.5s" },
  green: { word: "Green", dot: "#16A34A", text: "text-[#15803D]", soft: "bg-[#F0FDF4]", ping: "2.6s" },
  quiet: { word: "Quiet", dot: "#CBD5E1", text: "text-[#8C827A]", soft: "bg-sand-100", ping: null },
  off: { word: "Not scored", dot: "#E8E2D9", text: "text-[#A8A29E]", soft: "bg-sand-50", ping: null },
};

export function bandOf(row) {
  if (!row?.pulse_on) return "off";
  const s = row.snapshot;
  if (!s || !s.band) return "quiet";
  return s.band;
}

// "▼ 17 in 2 weeks · 9 to yellow" / "▲ 4" / "steady · 3 weeks" / "not enough activity this month"
export function movementLine(row) {
  const b = bandOf(row);
  const s = row?.snapshot;
  if (b === "off") return "not scored yet";
  if (b === "quiet") return s ? "not enough resident activity this month" : "first pulse tomorrow morning";
  const parts = [];
  const d = s.delta14;
  if (typeof d === "number" && d !== 0) parts.push(`${d > 0 ? "▲" : "▼"} ${Math.abs(d)} in 2 weeks`);
  else if (s.band_since_days >= 14) parts.push(`${Math.floor(s.band_since_days / 7)} week${Math.floor(s.band_since_days / 7) === 1 ? "" : "s"}`);
  else parts.push("steady");
  if (s.to_next?.band) parts.push(`${s.to_next.points} to ${s.to_next.band}`);
  return parts.join(" · ");
}

export const SIGNAL_ORDER = ["no_answer", "hanging", "follow_through", "unhappy", "repeat"];

export function lineText(sig, healthy, trouble) {
  const u = sig?.unit === "stars" ? "★" : "%";
  const hi = sig?.better === "high";
  return `${hi ? "≥" : "≤"} ${healthy}${u} healthy · ${hi ? "≤" : "≥"} ${trouble}${u} trouble`;
}

export function fmtTime(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }); } catch { return ""; }
}

export function ago(iso) {
  if (!iso) return "";
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (!Number.isFinite(m)) return "";
  if (m < 60) return `${Math.max(m, 0)}m ago`;
  if (m < 1440) return `${Math.floor(m / 60)}h ago`;
  const d = Math.floor(m / 1440);
  return d < 14 ? `${d}d ago` : fmtDay(iso.slice(0, 10));
}

export function fmtDay(day) {
  if (!day) return "";
  try { return new Date(`${day}T12:00:00`).toLocaleDateString([], { month: "short", day: "numeric" }); } catch { return day; }
}
